import { defineExperiment } from '@cian/experiments/ab';

/**
 * Имя эксперимента в сервисе ab-use. Заведено заказчиком/аналитиком —
 * само включение/выключение эксперимента там же выступает фичетоглом
 * для этой фичи на фронте.
 */
export const DEALS_EXPERIMENT_NAME = 'b2b_cpd_cian_magazine_add_cpd_banner';

export const DealsExperiment = defineExperiment(DEALS_EXPERIMENT_NAME, {
  groups: ['A', 'B'] as const,
  default: 'A',
});

export type TDealsExperimentGroup = (typeof DealsExperiment.groups)[number];
